import IMuiTheme from "types/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: IMuiTheme) => ({
  root: {
    padding: theme.spacing(3, 3, 0, 3),
  },
  rootAlert: {
    paddingRight: theme.spacing(3),
  },
  select: {
    width: "100%",

    "& .MuiInputBase-input": {
      paddingTop: theme.typography.pxToRem(14),
      paddingBottom: theme.typography.pxToRem(14),
    },
    "& .MuiSelect-select": {
      paddingTop: theme.typography.pxToRem(12),
      paddingBottom: theme.typography.pxToRem(12),
    },
  },
  relatedEventSelect: {
    width: "50%",
  },
  relatedEvent: {
    width: "100%",

    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
  },
  selectSpacing: {
    padding: "0.75rem 0",
    margin: 0,
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
  },
  form: {
    padding: theme.spacing(3, 3, 0, 3),
    height: "100%",
    overflowY: "auto",
  },
  formEvent: {
    padding: theme.spacing(3, 3, 0, 3),
    height: "85%",
    overflowY: "auto",
  },
  formAlert: {
    padding: theme.spacing(3, 3, 0, 0),
    height: "90%",
    overflowY: "auto",
  },
  multiSelect: {
    width: "100%",
  },
  input: {
    width: "100%",
  },
  fullHeight: {
    height: "100%",
  },
  inputTimePicker: {
    "& .MuiInputBase-input": {
      paddingTop: theme.typography.pxToRem(17),
      paddingBottom: theme.typography.pxToRem(17),
    },
  },
  order1: {
    order: 1,
  },
  order2: {
    order: 2,
  },
  order3: {
    order: 3,
  },
  order4: {
    order: 4,
  },
  footer: {
    padding: theme.spacing(1),
    boxShadow: "0 0 4px 0 rgba(0,0,0,0.24)",
  },
  radio: {
    marginLeft: theme.spacing(0.5),
  },
  mandatory: {
    paddingLeft: theme.spacing(3),
  },
  modalWrapper: {
    [`@media only screen and (min-width: ${theme.spacing(96)})`]: {
      width: "80%!important",
      height: "90%!important",
      minHeight: theme.spacing(75),
    },
    "& .MuiGrid-item": {
      paddingTop: 0,
    },
  },
  description: {
    minHeight: theme.spacing(10),
  },
  detail: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      gap: "1rem",
      flexWrap: "wrap",
    },

    "& > *": {
      width: "100%",
      padding: "0.75rem 0",
      margin: 0,
      [theme.breakpoints.up("md")]: {
        padding: 0,
        minWidth: "35%",
        maxWidth: "40%",
        flex: "1 1 0",
      },
    },
  },
  alertDetail: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      flexWrap: "wrap",
    },

    "& > *": {
      width: "100%",
      padding: "0.75rem 0",
      margin: 0,
      [theme.breakpoints.up("md")]: {
        padding: 0,
        minWidth: "35%",
        maxWidth: "100%",
        flex: "1 1 0",
      },
    },
  },

  contentWrapper: {
    display: "flex",
    flex: 1,
  },

  chatContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "100%",
  },

  chatBorder: {
    content: "",
    position: "absolute",
    top: theme.spacing(6),
    bottom: theme.spacing(2),
    left: 0,
    width: "1.5px",
    backgroundColor: theme.custom.palette.productionNote.regular,
  },

  chatWrapper: {
    zIndex: 999,
    position: "fixed",
    borderLeft: `2px solid ${theme.custom.palette.productionNote.regular}`,
    textAlign: "end",
    height: theme.spacing(60),
    marginTop: theme.spacing(4),

    [`@media only screen and (min-width: ${theme.spacing(
      102
    )}) and (min-height: ${theme.spacing(72)})`]: {
      height: theme.spacing(64),
    },
    [`@media only screen and (min-width: ${theme.spacing(
      130
    )}) and (min-height: ${theme.spacing(72)})`]: {
      height: theme.spacing(68),
    },
    [`@media only screen and (min-width: ${theme.spacing(
      160
    )}) and (min-height: ${theme.spacing(72)})`]: {
      height: theme.spacing(68),
    },
  },

  verticalText: {
    writingMode: "vertical-rl",
    textOrientation: "mixed",
    transform: "rotate(180deg)",
    fontSize: "16px",
    color: theme.custom.palette.productionNote.regular,
  },

  currencyWrapper: {
    display: "flex",
    gap: "1rem",
  },
  selectCurrency: {
    width: "30%",
  },
}));
